export const SCHEME_PAGE_VIEW_COMPONENT_IDS = ["1", "2", "3", "4"] as const;

const allowedIds = new Set<string>(SCHEME_PAGE_VIEW_COMPONENT_IDS);

export const sanitizeSchemePageView = (value: string | string[] | null | undefined): string[] => {
  const rawValue = Array.isArray(value) ? value : typeof value === "string" ? value.split("") : [];
  const seenIds = new Set<string>();
  const sanitized = rawValue.filter(id => {
    if (!allowedIds.has(id) || seenIds.has(id)) {
      return false;
    }

    seenIds.add(id);
    return true;
  });

  SCHEME_PAGE_VIEW_COMPONENT_IDS.forEach(id => {
    if (!seenIds.has(id)) {
      sanitized.push(id);
    }
  });

  return sanitized;
};
